<template>
  <div>
    <div class="toolbtn flex">
      <el-tooltip class="item" effect="dark" content="刷新" placement="top">
        <div @click="refresh()" class="cursorpointer margin-top10">
          <img
            src="@/assets/barsvg/icon／12sx(1).png"
            style="position: relative; top: 2px"
            alt=""
          />
          <span class="f12 pad-left5" style="color: #969eac">刷新</span>
        </div>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="返回" placement="top">
        <callback></callback>
      </el-tooltip>
    </div>
    <el-skeleton class="width100" :loading="true" animated :throttle="500">
      <template slot="template">
        <div class="width100 margin-auto backwhite border-rd3">
          <!-- 内容 -->
          <div
            class="
              width100
              text-ellipsis
              backwhite
              pad-bot20
              margin-top10
              border-rd3
            "
            v-if="total != 0"
          >
            <div
              class="
                f14
                lineheight35
                pad-left20 pad-right20 pad-top20 pad-bot10
                bordert-tf
                dimencont
              "
              v-for="(item, index) in pages"
              :key="index"
            >
              <div v-if="item.patent != null">
                <div class="f14 flex-betweennowrap cursorpointer dimensional">
                  <span @click="toPatentdatails(index)"
                    >{{ item.patent.title }}({{ item.patent.appNumber }})
                    <span
                      class="f12"
                      :class="
                        item.patent.dbName == '实用新型'
                          ? 'patensy'
                          : item.patent.dbName == '外观专利'
                          ? 'patenwg'
                          : item.patent.dbName == '发明专利'
                          ? 'patenzl'
                          : 'patensq'
                      "
                      >{{ item.patent.dbName }}</span
                    ></span
                  >
                  <p class="cursorpointer" @click="centerDialogVisible = true">
                    <span class="redcolor f12 margin-right10"
                      >已分享给：{{ item.company.company }}</span
                    >

                    <span>
                      <el-button @click="nullshare(index)">取消分享</el-button>
                    </span>
                  </p>
                </div>
                <p
                  class="width70 flex-betweennowrap pad-top10"
                  @click="toPatentdatails(index)"
                >
                  <span>公开(公告)号:{{ item.patent.pubNumber }}</span>
                  <span>申请（专利权）人：{{ item.patent.patentee }}</span>
                  <span> 发明（设计）人：{{ item.patent.inventroName }}</span>
                </p>
                <p class="width70 flex-betweennowrap">
                  <span>国省代码:{{ item.patent.proCode }}</span>
                  <span>申请日:{{ item.patent.appDate }} </span>
                  <span>公开(公告)日:{{ item.patent.pubDate }}</span>
                </p>
                <p>分类号:{{ item.patent.ipc }}</p>
                <p>主分类号:{{ item.patent.mainIpc }}</p>
              </div>
            </div>
            <!-- 分页 -->
            <div
              v-if="total != 0"
              class="
                flex-betweennowrap
                pad-top20 pad-bot20
                pagination
                pad-right10
                bordert-tf
              "
            >
              <span></span>
              <el-pagination
                :hide-on-single-page="true"
                @size-change="handleSizeChange"
                @current-change="currentchange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 30, 40, 50]"
                :page-size="per_page"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                background
              >
              </el-pagination>
            </div>
          </div>

          <div
            class="width100 margin-auto backgroudFFF margin-top15"
            v-if="total == 0"
          >
            <el-empty
              :image="require('@/assets/barsvg/zwsj@3x.png')"
              :image-size="200"
              description="抱歉，没有搜到您想要的内容"
              class="heightempty"
            >
              <p style="position: relative; bottom: 60px" class="f14">
                暂无数据
              </p>
            </el-empty>
          </div>
          <el-dialog
            title=""
            :visible.sync="dialogVisiblenull"
            :close-on-click-modal="false"
            :show-close="true"
            :center="true"
            :modal="true"
            :modal-append-to-body="true"
            :append-to-body="true"
            width="25%"
            class="errorbox"
          >
            <span class="errormessage">{{ errormessage }}</span>
            <span slot="footer" class="dialog-footer">
              <button @click="dialogVisiblenull = false" class="errorbutton">
                确 定
              </button>
            </span>
          </el-dialog>
        </div>
      </template>
    </el-skeleton>
  </div>
</template>
<script>
import {
  followpatentmyshare,
  followpatentclose,
} from "@/api/patent/patent.api";
import callback from "@/components/callback.vue";
import BUS from "@/BUS/BUS";
export default {
  data() {
    return {
      errormessage: "",
      dialogVisiblenull: false,
      thisNum: 1,
      pages: [],
      total: 0,
      per_page: 0,
      currentPage: 1,
      pagination: false,
      centerDialogVisible: false,
      Remind: 0,
      behalf: 0,
      sell: 0,
      date: "",
      serchkey: true,
      input: "",
    };
  },
  components: {
    callback,
  },

  methods: {
    // 取消分享
    nullshare(index) {
      this.$confirm("此操作将取消分享, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          followpatentclose({ id: this.pages[index].id }).then((res) => {
            if (res.data.code == 200) {
              this.$message({
                showClose: true,
                message: "取消分享成功",
                type: "success",
              });
              this.refresh();
            } else {
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // 跳转详情
    toPatentdatails(index) {
      window.sessionStorage.setItem(
        "patentlookout",
        this.pages[index].patent.id
      );
      this.$router.push({
        path: "/intellectual-property/patentlookout-details",
      });
    },
    // 第一个分页
    currentchange(val) {
      this.thisNum = val;
      followpatentmyshare({
        page: val,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.pages = res.data.data.data;

          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
          this.pages.forEach((i) => {
            if (i.dbName == "SYXX") {
              i.dbName = "实用新型";
            }
            if (i.dbName == "FMZL") {
              i.dbName = "发明专利";
            }
            if (i.dbName == "WGZL") {
              i.dbName = "外观专利";
            }
            if (i.dbName == "FMSQ") {
              i.dbName = "发明授权";
            }
          });
        } else {
          this.drawer = false;
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    handleSizeChange(val) {
      followpatentmyshare({
        page: 1,
        limit: val,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.pages = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
          this.pages.forEach((i) => {
            if (i.dbName == "SYXX") {
              i.dbName = "实用新型";
            }
            if (i.dbName == "FMZL") {
              i.dbName = "发明专利";
            }
            if (i.dbName == "WGZL") {
              i.dbName = "外观专利";
            }
            if (i.dbName == "FMSQ") {
              i.dbName = "发明授权";
            }
          });
        } else {
          this.drawer = false;
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    refresh() {
      this.$loading.show(); // 显示loading
      followpatentmyshare({
        page: this.thisNum,
      }).then((res) => {
        if (res.data.code == 200) {
          this.pagination = true;
          this.$loading.hide(); // 隐藏loading
          this.pages = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
          this.pages.forEach((i) => {
            if (i.patent.dbName == "SYXX") {
              i.patent.dbName = "实用新型";
            }
            if (i.patent.dbName == "FMZL") {
              i.patent.dbName = "发明专利";
            }
            if (i.patent.dbName == "WGZL") {
              i.patent.dbName = "外观专利";
            }
            if (i.patent.dbName == "FMSQ") {
              i.patent.dbName = "发明授权";
            }
          });
          this.$loading.hide(); // 隐藏loading
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
  },

  created() {
    window.sessionStorage.setItem("default", "个人中心");
    BUS.$on("serchkey", (data) => {
      this.serchkey = data;
    });

    this.$loading.show(); // 显示loading
    followpatentmyshare({
      page: this.thisNum,
    }).then((res) => {
      if (res.data.code == 200) {
        this.pagination = true;
        this.$loading.hide(); // 隐藏loading
        this.pages = res.data.data.data;
        this.total = res.data.data.total;
        this.per_page = res.data.data.per_page;
        this.pages.forEach((i) => {
          if (i.patent.dbName == "SYXX") {
            i.patent.dbName = "实用新型";
          }
          if (i.patent.dbName == "FMZL") {
            i.patent.dbName = "发明专利";
          }
          if (i.patent.dbName == "WGZL") {
            i.patent.dbName = "外观专利";
          }
          if (i.patent.dbName == "FMSQ") {
            i.patent.dbName = "发明授权";
          }
        });
      } else {
        this.$loading.hide(); // 隐藏loading
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
};
</script>
<style scoped>
.patensy {
  color: #7b83ea;
  padding: 2px 10px 2px 10px;
  /* opacity: 0.1; */
  background: #ebecf1;
  border-radius: 11px;
}
.patenwg {
  color: #52c5cb;
  padding: 2px 10px 2px 10px;
  /* opacity: 0.1; */
  background: #e1e5e6;
  border-radius: 11px;
}
.patenzl {
  color: #f96d68;
  padding: 2px 10px 2px 10px;
  /* opacity: 0.1; */
  background: #e9e2e1;
  border-radius: 11px;
}
.patensq {
  color: #5599ff;
  padding: 2px 10px 2px 10px;
  /* opacity: 0.1; */
  background: #eaebee;
  border-radius: 11px;
}
.patenbtn {
  background: #678feb;
  color: #f9f9f9;
  padding: 5px 10px 5px 10px;
  border-radius: 3px;
}
.patenbtn:hover {
  background: #87a5ec;
}
.redcolor {
  color: red;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
</style>